import {
  FETCH_USER_DETAILS_REQUEST,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  TOKEN_EXPIRED,
  INVALID_TOKEN,
} from './userDetailsTypes';
import { axiosInstanceNext } from '../../axios/axios';
import { VERIFY_TOKEN } from '../../axios/appiendPoints';
import {
  getUserId,
  getUserToken,
  isGuestUser,
  removeUserId,
  removeUserStatus,
  removeUserToken,
} from '../../webStorage/localStorage';
import { replaceGuest } from '../../component/login/httpServices/tokenHttp';

export const fetchUserDetailsRequest = () => ({
  type: FETCH_USER_DETAILS_REQUEST,
});

export const fetchUserDetailsSuccess = (details) => ({
  type: FETCH_USER_DETAILS_SUCCESS,
  payload: details,
});

export const fetchUserDetailsFailure = (error) => ({
  type: FETCH_USER_DETAILS_FAILURE,
  payload: error,
});

let verifyUserInFlight = null;

export const fetchUser = (setIsUserGuest, force = false) => {
  const token = getUserToken();
  if (!token || token === 'undefined') {
    return (dispatch) => dispatch(fetchUserDetailsFailure('token not found'));
  }

  return (dispatch, getState) => {
    const { userDetails } = getState();
    if (!force && userDetails?.isLoaded && userDetails?.Details?.data?.status === 1) {
      setIsUserGuest && setIsUserGuest(isGuestUser());
      return Promise.resolve(userDetails.Details);
    }

    if (verifyUserInFlight) {
      return verifyUserInFlight;
    }

    dispatch(fetchUserDetailsRequest());

    const params = new URLSearchParams();
    params.append('token', token);

    verifyUserInFlight = axiosInstanceNext
      .post(VERIFY_TOKEN, params)
      .then((response) => {
        const details = response.data;
        if ([TOKEN_EXPIRED, INVALID_TOKEN].includes(response?.data?.status)) {
          dispatch(
            fetchUserDetailsFailure(
              `something went wrong. response status:${response?.data?.status}`
            )
          );
          removeUserToken();
          removeUserId();
          removeUserStatus();
          return null;
        }

        // Real logged-in user from VERIFY_TOKEN — clear stale GUEST flag in localStorage
        const verifiedUser = response?.data?.data;
        if (verifiedUser?.name || verifiedUser?.token_verified === '1') {
          removeUserStatus();
        }

        if (isGuestUser() && getUserId() !== verifiedUser?.user_id) {
          return replaceGuest(getUserId(), verifiedUser?.user_id).then((res) => {
            if (res?.data?.data?.status === 1) {
              removeUserStatus();
              setIsUserGuest && setIsUserGuest(isGuestUser());
              dispatch(fetchUserDetailsSuccess(details));
              return details;
            }
            return null;
          });
        }

        setIsUserGuest && setIsUserGuest(isGuestUser());
        localStorage.setItem('user_id', verifiedUser?.user_id);
        dispatch(fetchUserDetailsSuccess(details));
        return details;
      })
      .catch((err) => {
        console.log('Error:', err);
        dispatch(fetchUserDetailsFailure(err.message));
        return null;
      })
      .finally(() => {
        verifyUserInFlight = null;
      });

    return verifyUserInFlight;
  };
};
